import styled from 'styled-components';
import PreviewImage from 'gatsby-theme-vehicles/src/components/preview/components/image';

export default styled(PreviewImage)`
  border-radius: inherit;
`;
